<template>
  <div>
    <!-- Vehicle Filter -->
    <form id="vehicles-filter-form" class="vehicle-search-contract-parameters-component">
      <div class="container">
        <div class="row">

          <!-- Vehicle Filters -->
          <div class="col-12">
            <div class="d-flex flex-row justify-content-between">

              <div>
                <button class="filter w-100 text-start d-flex flex-row justify-content-between" type="button"
                  @click="showFilters=!showFilters"
                >
                  <span>Filter your options</span>
                </button>
              </div>

              <div class="d-flex align-items-center">
                <button class="reset" @click.prevent="resetFormData()"><span>Reset</span></button>
              </div>

            </div>
          </div>

        </div>
      </div>

      <!-- Vehicle Filters -->
      <div id="vehicle-filters" :class="{ 'd-none': !showFilters }">
        <div class="container">

          <div class="row row-cols-3">
            <!-- Manufacturers -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="manufacturer">Manufacturer</label>
                <multiselect
                  id="manufacturer"
                  v-if="manufacturers"
                  v-model="vueMultiSelectManufacturers"
                  placeholder="Select"
                  label="manufacturerName"
                  track-by="manufacturerName"
                  option="manufacturerID"
                  :multiple="true"
                  :options="manufacturers"
                  @update:model-value="setRangeOptions($event)"
                >
                </multiselect>
              </div>
            </div>
            <!-- Ranges -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="ranges">Range</label>
                <multiselect
                  id="ranges"
                  v-if="formData && ranges"
                  v-model="vueMultiSelectRanges"
                  placeholder="Select"
                  label="rangeName"
                  track-by="rangeName"
                  option="rangeID"
                  :multiple="true"
                  :options="ranges"
                  @update:model-value="setModelOptions($event)"
                >
                  <span slot="noOptions">
                      Please select a manufacturer
                  </span>
                </multiselect>
              </div>
            </div>
            <!-- Models -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="models">Model</label>
                <multiselect
                  id="models"
                  v-if="formData && models"
                  v-model="vueMultiSelectModels"
                  placeholder="Select"
                  label="modelName"
                  track-by="modelName"
                  option="modelID"
                  :multiple="true"
                  :options="models"
                  @update:model-value="updateSearchResults($event)"
                >
                  <span slot="noOptions">
                      Please select a range
                  </span>
                </multiselect>
              </div>
            </div>
          </div>

          <div class="row row-cols-3">
            <!-- Fuel Types -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="fuel_type">Fuel Type</label>
                <multiselect
                  id="fuel_type"
                  v-if="formData && filters"
                  v-model="vueMultiSelectFuelTypes"
                  placeholder="Select"
                  label="fuelTypeDescription"
                  track-by="fuelTypeDescription"
                  option="fuelTypeID"
                  :multiple="true"
                  :options="filters.fuelTypes"
                  @update:model-value="updateFuelTypes($event)"
                >
                </multiselect>
              </div>
            </div>
            <!-- Minimum Electric Range -->
            <!-- <div class="col">
                <div class="custom-multiselect">
                    <label for="minimum_electric_range">Minimum Electric Range</label>
                    <multiselect
                        id="minimum_electric_range"
                        v-if="formData && filters"
                        v-model="vueMultiSelectMinimumElectricRanges"
                        placeholder="Select"
                        label="minimumElectricRange"
                        track-by="minimumElectricRange"
                        option="minimumElectricRangeID"
                        :multiple="true"
                        :options="filters.minimumElectricRanges"
                        @select="updateMinimumElectricRanges($event)"
                    >
                    </multiselect>
                </div>
            </div> -->
            <!-- Transmission Types -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="transmission">Transmission</label>
                <multiselect
                  id="transmission"
                  v-if="formData && filters"
                  v-model="vueMultiSelectTransmission"
                  placeholder="Select"
                  label="transmissionTypeDescription"
                  track-by="transmissionTypeDescription"
                  option="transmissionTypeDescription"
                  :multiple="false"
                  :options="filters.transmissionTypes"
                  @update:model-value="updateTransmissionTypes($event)"
                />
              </div>
            </div>
          </div>

          <div class="row row-cols-3">
            <!-- Body Types -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="body-type">Body Type</label>
                <multiselect
                  id="body-type"
                  v-if="formData && filters"
                  v-model="vueMultiSelectBodyType"
                  placeholder="Select"
                  label="bodyStyleDescription"
                  track-by="bodyStyleDescription"
                  option="bodyStyleID"
                  :multiple="true"
                  :options="filters.bodyStyles"
                  @update:model-value="updateBodyTypes($event)"
                />
              </div>
            </div>

            <!-- 4 Wheel Drive Options -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="4-wheel-drive">4 Wheel Drive</label>
                <multiselect
                  id="4-wheel-drive"
                  v-if="formData && fourWheelDriveOptions"
                  v-model="vueMultiSelectFourWheelDrive"
                  placeholder="Select"
                  label="description"
                  track-by="description"
                  option="value"
                  :multiple="false"
                  :options="fourWheelDriveOptions"
                  @update:model-value="updateFourWheelDrive($event)"
                />
              </div>
            </div>
            <!-- Minimum No. Seats -->
            <div class="col">
              <div class="custom-multiselect">
                <label for="minimum-number-of-seats">Minimum Number of seats</label>
                <multiselect
                  id="minimum-number-of-seats"
                  v-if="formData && filters"
                  v-model="vueMultiSelectMinSeats"
                  placeholder="Select"
                  label="noOfSeats"
                  track-by="noOfSeats"
                  option="noOfSeats"
                  :multiple="false"
                  :options="filters.noOfSeats"
                  @update:model-value="updateMinSeats($event)"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="row row-cols-1 contract-parameters">
            <div class="col">
              <h4>Contract Parameters</h4>
            </div>
          </div>

          <div class="row row-cols-4">
            <!-- BIK Values -->
            <div class="col" v-if="formData">
              <div class="range">
                <div class="nus">
                  <span class="d-block">BIK Values</span>
                  <label for="bik-values-from">
                    <input type="text" :value="currency(formData.body_params.MinBIK)" id="bik-values-from"
                      class="text-start" disabled>
                  </label>
                  <label for="bik-values-to">
                    <input type="text" :value="currency(formData.body_params.MaxBIK)" id="bik-values-to"
                      class="text-end" disabled>
                  </label>
                </div>
                <Slider
                  v-bind="bikRangeConfig"
                  v-model="bikRangeConfig.value"
                  @slide="updateRangeSliderInput(['MinBIK','MaxBIK'], $event)"
                  @change="$parent.updateSearchResults"
                />
              </div>
            </div>
            <!-- P11d -->
            <div class="col" v-if="formData">
              <div class="range">
                <div class="nus">
                  <span class="d-block">P11d</span>
                  <label for="p11d-from">
                    <input type="text" :value="currency(formData.body_params.MinP11DValue)" id="p11d-from"
                      class="text-start" disabled>
                  </label>
                  <label for="p11d-to">
                    <input type="text" :value="currency(formData.body_params.MaxP11DValue)" id="p11d-to"
                      class="text-end" disabled>
                  </label>
                </div>
                <Slider
                  v-bind="p11dRangeConfig"
                  v-model="p11dRangeConfig.value"
                  @slide="updateRangeSliderInput(['MinP11DValue','MaxP11DValue'], $event)"
                  @change="$parent.updateSearchResults"
                />
              </div>
            </div>
            <!-- Term -->
            <div class="col" v-if="formData.body_params.Term">
              <div class="input input d-flex flex-column bg-transparent term-icon">
                <input type="text" v-model="formData.body_params.Term" id="term" class="order-1" disabled>
                <label for="term" class="order-0">Term</label>
              </div>
            </div>
            <!-- Total Mileage -->
            <div class="col" v-if="formData.body_params.AnnualDistance">
              <div class="input input d-flex flex-column bg-transparent total-mileage-icon">
                <input type="text" v-model="formData.body_params.AnnualDistance" id="total-mileage" class="order-1"
                  disabled>
                <label for="total-mileage" class="order-0">Annual Contract Mileage</label>
              </div>
            </div>
          </div>

        </div>
      </div>

    </form>

    <!-- Filter Results -->
    <div id="filter-results">
      <div class="container">
        <div class="row">

          <div class="col-auto">
            <button @click="showShortlist(false)" :class="{ active: showShortlistedCars === false }"
              class="all-cars text-uppercase">All Cars
            </button>
            <button @click="showShortlist(true)" :class="{ active: showShortlistedCars }"
              class="my-shortlisted-cars text-uppercase" v-if="false">My Shortlisted Cars
            </button>
          </div>

          <div class="col">

            <!-- Search -->
            <div class="search">
              <label for="search"><i class="icon-search"></i></label>
              <input id="search" type="text" v-model="formData.body_params.TextSearch" @keyup="triggerSearchCountdown"
                placeholder="Search Vehicles" @keydown.enter.prevent>
            </div>

          </div>

          <div class="col-auto">
            <div class="w-100 d-flex flex-row justify-content-between">
              <!-- Filter By -->
              <div class="filter-by" v-if="driverGrades.length > 1">
                <label for="filter-by">Filter By Driver Grade</label>
                <div class="select">
                  <select id="driver-grade" name="driver-grade" v-model="formData.body_params.DriverGradeID" @change="updateDriverGrade">
                    <option v-for="grade in driverGrades" :value="grade.id">{{ grade.value }}</option>
                  </select>
                </div>
              </div>

              <!-- Sort By -->
              <div class="sort-by">
                <label for="sort-by">Sort by</label>
                <div class="select">
                  <select id="sort-by" name="sort-by" v-model="sortBy">
                    <option v-if="canShowMonthlyRentalFilter" value="RENTAL">Monthly Payment</option>
                    <option value="P11DVALUE">Vehicle Value</option>
                    <option value="MANUFACTURERNAME">Vehicle Manufacturer</option>
                    <option value="MODELNAME">Vehicle Model</option>
                  </select>
                </div>
              </div>

              <!-- Order By -->
              <div class="order-by">
                <button v-on:click.prevent="changeSortOrder" :value="sortOrder">
                  <i :class="`icon-${sortOrder.toLowerCase()}`"></i>
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>


<script>

import {EventBus} from '@/event-bus';
import Multiselect from 'vue-multiselect'
import {currency} from '@/helpers/filters';
import Slider from '@vueform/slider'
import {useRoute} from 'vue-router'

/* require('../vue-nouislider'); */

let searchCountdownTimeout;

let filterDefaultsObject = {
  vueMultiSelectManufacturers: [],
  vueMultiSelectRanges: [],
  vueMultiSelectModels: [],
  vueMultiSelectFuelTypes: [],
  vueMultiSelectMinimumElectricRanges: [],
  vueMultiSelectTransmission: [],
  vueMultiSelectBodyType: [],
  vueMultiSelectFourWheelDrive: [],
  vueMultiSelectMinSeats: [],
  vueSelectedDriverGrade: '',

  sortBy: 'RENTAL',
  sortOrder: 'ASC',

  bikRangeConfig: {
    step: 5,
    min: 0,
    max: 1500,
    tooltips: false,
    value: [0, 1500],
  },

  p11dRangeConfig: {
    step: 100,
    min: 0,
    max: 125000,
    tooltips: false,
    value: [0, 125000],
  },

  showFilters: false,
};

function filterDefaults() {
  return filterDefaultsObject;
}

export default {
  components: {
    EventBus,
    Multiselect,
    Slider
  },

  props: [
    'formData',
    'manufacturers',
    'filters',
    'fourWheelDriveOptions',
    'ranges',
    'models',
    'showShortlistedCars',
    'adminPortalData',
    'canShowMonthlyRentalFilter',
    'driverGrades',
    'defaultSort',
    'scheme',
  ],

  data() {
    return filterDefaultsObject
  },

  setup() {
    const route = useRoute()
    return { route }
  },

  mounted() {
    EventBus.$on('shortlistUpdated', (count) => {
      this.shortlistCount = count;
    });

    EventBus.$on('resetFilters', (count) => {
      this.resetFormData();
    });

    this.$parent.updateSearchResults();
  },

  beforeMount() {
    const scheme = this.route.params.scheme;
    if (scheme && this.adminPortalData?.content?.products?.[scheme]?.[0]?.your_shortlist_default_sort) {
      this.sortBy = this.adminPortalData.content.products[scheme][0].your_shortlist_default_sort;
      this.sortOrder = this.adminPortalData.content.products[scheme][0].your_shortlist_default_sort_order;
    }
  },

  computed: {
    canShowMonthlyRentalFilter() {
      if (this.route.params.scheme === 'salsac') {
        return false;

      } else if (this.route.params.scheme === 'bch') {
        // This should be amended to account for monthly rental when enabled for BCH
        return false;
      }

      return true;
    },

    selectedDriverGrade: {
      set() {
        return this.driverGrades.find(grade => grade.id === this.vueSelectedDriverGrade);
      },

      get() {
        if(this.vueSelectedDriverGrade === '') {
          return this.driverGrades[0].id;
        }
        return this.driverGrades.find(grade => grade.id === this.vueSelectedDriverGrade);
      }
    }
  },

  methods: {
    currency,

    toggleFilters() {
      this.showFilters = !this.showFilters;
    },

    updateRangeSliderInput(inputs, values) {
      this.formData.body_params[inputs[0]] = values[0];
      this.formData.body_params[inputs[1]] = values[1];
    },

    showShortlist(value) {
      EventBus.$emit('showShortlistedCars', value)
    },

    setRangeOptions(event) {
      //this.resetSelections(true, true);

      // Vue multi-select doesn't offer an array of
      // values, so we need to pluck them instead!
      this.formData.body_params.ManufacturerID = collect(event).pluck('manufacturerID').all();

      this.$parent.rangesRequireRefresh = true;

      // we need to remove selected ranges that no longer apply to the current manufacturer selection
      const whittledSelectedRangeIds = this.ranges.map(range => {
        if ((this.formData.body_params.RangeID.indexOf(range.rangeID) !== -1) // range is already selected
          && (this.formData.body_params.ManufacturerID.indexOf(range.manufacturerID) !== -1) // and range is within currently selected set of manufacturers
        ) {
          return range.rangeID;
        }
      });

      Promise.all(whittledSelectedRangeIds).then((whittledSelectedRangeIds) => {
        this.formData.body_params.RangeID = whittledSelectedRangeIds.filter(id => id !== undefined);
        this.setModelOptions();
      });

    },

    setModelOptions(event) {
      //this.resetSelections(false, true);

      // Vue multi-select doesn't offer an array of
      // values, so we need to pluck them instead!
      this.formData.body_params.RangeID = collect(event).pluck('rangeID').all();

      this.$parent.modelsRequireRefresh = true;

      if (this.formData.body_params.RangeID.length) {

        // we need to remove selected models that no longer apply to the current manufacturer selection
        const whittledSelectedModelIds = this.models.map(model => {
          if ((this.formData.body_params.ModelID.indexOf(model.modelID) !== -1) // model is already selected
            && (this.formData.body_params.RangeID.indexOf(model.rangeID) !== -1) // and model is within currently selected set of manufacturers
          ) {
            return model.modelID;
          }
        });

        Promise.all(whittledSelectedModelIds).then((whittledSelectedModelIds) => {
          this.formData.body_params.ModelID = whittledSelectedModelIds.filter(id => id !== undefined);
          this.$parent.updateSearchResults();
        });

      } else {
        this.formData.body_params.ModelID = [];
        this.$parent.models = [];
        this.$parent.updateSearchResults();
      }
    },

    resetFormData() {
      this.resetSelections(true, true, true);
      Object.assign(this.$data, filterDefaults());

      this.$parent.resetFormData(this.$parent.updateSearchResults())
    },

    resetSelections(clearManufacturer, clearRanges, clearModels) {
      if (clearManufacturer) {
        this.vueMultiSelectManufacturers = [];
        this.formData.body_params.ManufacturerID = [];
      }

      if (clearRanges) {
        this.vueMultiSelectRanges = [];
        this.formData.body_params.RangeID = [];
      }

      if (clearModels) {
        this.vueMultiSelectModels = [];
        this.formData.body_params.ModelID = [];
      }

      this.vueMultiSelectFuelTypes = [];
      this.formData.body_params.FuelType = [];

      this.vueMultiSelectMinimumElectricRanges = [];
      //this.formData.body_params.MinimumElectricRange = [];

      this.vueMultiSelectTransmission = [];
      this.formData.body_params.TransmissionType = null;

      this.vueMultiSelectBodyType = [];
      this.formData.body_params.BodyStyle = [];

      this.vueMultiSelectFourWheelDrive = [];
      this.formData.body_params.FourWheelDrive = null;

      this.vueMultiSelectMinSeats = [];
      this.formData.body_params.MinNoOfSeats = 0;
    },

    updateSearchResults(event) {
      this.formData.body_params.ModelID = collect(event).pluck('modelID').all();
      this.$parent.updateSearchResults()
    },

    updateFuelTypes(event) {
      this.formData.body_params.FuelType = collect(event).pluck('fuelTypeID').all();
      this.$parent.updateSearchResults()
    },

    updateMinimumElectricRanges(event) {
      this.formData.body_params.MinimumElectricRange = collect(event).pluck('minimumElectricRangeID').all();
      this.$parent.updateSearchResults()
    },

    updateTransmissionTypes(event) {
      this.formData.body_params.TransmissionType = collect(event).pluck('transmissionTypeDescription').first();
      this.$parent.updateSearchResults()
    },

    updateBodyTypes(event) {
      this.formData.body_params.BodyStyle = collect(event).pluck('bodyStyleID').all();
      this.$parent.updateSearchResults()
    },

    updateFourWheelDrive(event) {
      this.formData.body_params.FourWheelDrive = event.value;
      this.$parent.updateSearchResults()
    },

    updateMinSeats(event) {
      this.formData.body_params.MinNoOfSeats = event.noOfSeats;
      this.$parent.updateSearchResults()
      /*this.formData.body_params.MinNoOfSeats = event;
      this.$parent.updateSearchResults()*/
    },

    updateDriverGrade() {
      this.$parent.updateSearchResults()
    },

    changeSortOrder() {
      this.sortOrder = this.sortOrder.toLowerCase() === 'asc' ? 'desc' : 'asc';
    },

    triggerSearchCountdown() {
      clearTimeout(searchCountdownTimeout);
      searchCountdownTimeout = setTimeout(() => {
        this.$parent.updateSearchResults();
      }, 800);
    },

    // When sorting by manufacturer, tweak the order to then also sort by model name to get it truly alphabetical
    processedSortOrder() {
      let sort = this.sortBy + ' ' + this.sortOrder;
      if (this.sortBy === 'MANUFACTURERNAME') {
        sort = 'manufacturerName ' + this.sortOrder + ', modelName ' + this.sortOrder;
      }
      return sort;
    }
  },

  watch: {
    sortOrder: function () {
      this.formData.uri_params.OrderBy = this.processedSortOrder();
      this.$parent.updateSearchResults();
    },

    sortBy: function () {
      this.formData.uri_params.OrderBy = this.processedSortOrder();
      this.$parent.updateSearchResults();
    }
  },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
